<template>
    <div id="signup" class="cta-sm">
        <div class="container-m text-center">
            <div class="cta-content">
                <h4>Mauricio Sebastián Neira</h4>
                <h1>Contact me ;)</h1>
                <div class="form wow fadeIn" data-wow-delay="0.2s">
                    <form id="chimp-form" class="subscribe-form wow zoomIn" autocomplete="off" novalidate></form>
                        <h3>mauriciosneira@gmail.com</h3>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Contact',
}
</script>

<style lang="stylus">
@media only screen and (min-width: 240px)
    .cta-sm 
        padding 100px 0 100px 0
        background rgba(30, 166, 154, 0.1)
        background #f8faff
        background #f6f6fd
        height 650px
        .cta-content 
            max-width 768px
            margin 0 auto
        h1 
            font-size 28px
            font-weight 600
            color #364655
            line-height 1.6
        h4 
            font-size 13px
            font-weight 400
            color #aeaeae
            letter-spacing 1px
            margin-bottom 0
    .form 
        position relative
        max-width 420px
        margin 0 auto
        margin-top 30px


</style>